module.exports = __webpack_public_path__ + "img/slide_remates.e9a01633.jpeg";